'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactScrollspy = require('react-scrollspy');

var _utils = require('helpers/utils');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _reactScroll = require('react-scroll');

var _reactScroll2 = _interopRequireDefault(_reactScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scroll = _reactScroll2.default.animateScroll;

function removeSpaces(text) {
  return text.replace(/[\s\W]/g, '');
}

function getId(text) {
  return removeSpaces(text).toLowerCase();
}

// since link anchors don't working on iOS use js scroll to anchors
var scrollTo = function scrollTo(id) {
  if (!document) {
    return false;
  }
  var el = document.querySelector('#' + id);
  if (el) {
    scroll.scrollMore(el.getBoundingClientRect().top);
  }
};

var InfoPartition = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(InfoPartition, _Component);

  function InfoPartition() {
    (0, _classCallCheck3.default)(this, InfoPartition);
    return (0, _possibleConstructorReturn3.default)(this, (InfoPartition.__proto__ || (0, _getPrototypeOf2.default)(InfoPartition)).apply(this, arguments));
  }

  (0, _createClass3.default)(InfoPartition, [{
    key: 'render',
    value: function render() {
      var styles = require('./infoPartition.scss');
      var _props = this.props,
          text = _props.text,
          _props$text = _props.text,
          preKey = _props$text.preKey,
          articles = _props$text.articles,
          user = _props.user;


      var headers = [];
      var nav = [];

      var content = articles.map(function (article) {
        var header = article.header,
            chapter = article.chapter,
            bodies = article.bodies;

        var _id = getId(article.key);
        headers.push(_id);
        var parentKey = article.key;
        var body = bodies.map(function (item, index) {
          var key = preKey + parentKey + index;
          return _react2.default.createElement(
            'div',
            { className: styles.body, key: key },
            item
          );
        });

        nav.push(_react2.default.createElement(
          'li',
          { className: styles.scrollSpyItemCont, key: 'scroll-spy-' + _id },
          _react2.default.createElement(
            'a',
            { className: styles.scrollSpyItem, onClick: function onClick(e) {
                return (0, _utils.stopEvent)(e) && scrollTo(_id);
              } },
            chapter === null ? '' : chapter || header
          )
        ));
        return _react2.default.createElement(
          'section',
          { className: styles.section, key: 'section-' + article.key },
          _react2.default.createElement(
            'a',
            { className: 'anchor', id: _id },
            '\xA0'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.header },
            header
          ),
          body
        );
      });

      return _react2.default.createElement(
        'div',
        { className: 'margin-top-20' },
        _react2.default.createElement(
          'div',
          { className: (0, _bind2.default)('col-xs-60', styles.scrollSpy, (0, _defineProperty3.default)({}, styles.withMenu, !!user)) },
          _react2.default.createElement(
            _reactScrollspy.Scrollspy,
            { items: headers, currentClassName: styles.scrollSpyCurrent },
            nav
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-60 col-lg-35 ' + styles.content },
          text.body && _react2.default.createElement(
            'section',
            { className: styles.section },
            _react2.default.createElement(
              'div',
              { className: styles.body },
              text.body
            )
          ),
          content
        )
      );
    }
  }]);
  return InfoPartition;
}(_react.Component), _class2.propTypes = {
  text: _propTypes2.default.object,
  user: _propTypes2.default.object
}, _temp)) || _class);
exports.default = InfoPartition;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Info/InfoPartition/InfoPartition.js
// module id = 181
// module chunks = 1